import pm1 from "./assets/PM1.JPG";
import pm2 from "./assets/PM2.JPG";
import pm3 from "./assets/PM3.png";
import pm4 from "./assets/PM4.JPG";
import pm5 from "./assets/PM5.JPG";
import pm6 from "./assets/PM6.JPG";
import pm7 from "./assets/PM7.JPG";
import pm8 from "./assets/PM8.png";
import pm9 from "./assets/PM9.png";
import pm10 from "./assets/PM10.png";
import pm11 from "./assets/PM11.JPG";
import pm12 from "./assets/PM12.JPG";
import pm13 from "./assets/PM13.png";
import pm14 from "./assets/PM14.png";
import pm15 from "./assets/PM15.png";
import pm16 from "./assets/PM16.png";
import pm17 from "./assets/PM17.png";
import pm18 from "./assets/PM18.png";
import pm19 from "./assets/PM19.png";
import pm20 from "./assets/PM20.JPG";
import pm21 from "./assets/PM21.JPG";
import pm22 from "./assets/PM22.JPG";
import pm23 from "./assets/PM23.png";
import pm24 from "./assets/PM24.JPG";
import pm25 from "./assets/PM25.JPG";
import pm26 from "./assets/PM26.png";
import pm27 from "./assets/PM27.JPG";
import pm28 from "./assets/PM28.png";
import pm29 from "./assets/PM29.png";
import pm30 from "./assets/PM30.png";
import pm31 from "./assets/PM31.png";
import pm32 from "./assets/PM32.png";
import pm33 from "./assets/PM33.png";
import pm34 from "./assets/PM34.png";
import pm35 from "./assets/PM35.JPG";
import pm36 from "./assets/PM36.png";
import pm37 from "./assets/PM37.png";
import pm38 from "./assets/PM38.png";
import pm39 from "./assets/PM39.png";
import pm40 from "./assets/PM40.png";
import pm41 from "./assets/PM41.png";
import pm42 from "./assets/PM42.JPG";
import pm43 from "./assets/PM43.JPG";
import pm44 from "./assets/PM44.JPG";
import pm45 from "./assets/PM45.png";
import pm46 from "./assets/PM46.png";
import pm47 from "./assets/PM47.JPG";
import pm48 from "./assets/PM48.png";
import pm49 from "./assets/PM49.png";
import pm50 from "./assets/PM50.png";
import pm51 from "./assets/PM51.JPG";
import pm52 from "./assets/PM52.png";
import pm53 from "./assets/PM53.JPG";
import pm54 from "./assets/PM54.JPG";
import pm55 from "./assets/PM55.png";
import pm56 from "./assets/PM56.png";
import pm57 from "./assets/PM57.JPG";
import pm58 from "./assets/PM58.png";
import pm59 from "./assets/PM59.png";
import pm60 from "./assets/PM60.JPG";
import pm61 from "./assets/PM61.JPG";
import pm62 from "./assets/PM62.png";
import pm63 from "./assets/PM63.png";
import pm64 from "./assets/PM64.JPG";
import pm65 from "./assets/PM65.png";
import pm66 from "./assets/PM66.png";
import pm67 from "./assets/PM67.JPG";
import pm68 from "./assets/PM68.JPG";
import pm69 from "./assets/PM69.JPG";
import pm70 from "./assets/PM70.JPG";
import pm71 from "./assets/PM71.png";
import pm72 from "./assets/PM72.JPG";
import pm73 from "./assets/PM73.JPG";
import pm74 from "./assets/PM74.png";
import pm75 from "./assets/PM75.JPG";
import pm76 from "./assets/PM76.JPG";
import pm77 from "./assets/PM77.JPG";
import pm78 from "./assets/PM78.png";
import pm79 from "./assets/PM79.png";
import pm80 from "./assets/PM80.png";
import pm81 from "./assets/PM81.png";
import pm82 from "./assets/PM82.JPG";
import pm83 from "./assets/PM83.JPG";
import pm84 from "./assets/PM84.png";
import pm85 from "./assets/PM85.png";
import pm86 from "./assets/PM86.png";
import pm87 from "./assets/PM87.png";
import pm88 from "./assets/PM88.png";
import pm89 from "./assets/PM89.JPG";
import pm90 from "./assets/PM90.png";
import pm91 from "./assets/PM91.png";
import pm92 from "./assets/PM92.png";
import pm93 from "./assets/PM93.png";
import pm94 from "./assets/PM94.png";
import pm95 from "./assets/PM95.png";
import pm96 from "./assets/PM96.png";
import pm97 from "./assets/PM97.png";
import pm98 from "./assets/PM98.png";
import pm99 from "./assets/PM99.JPG";
import pm100 from "./assets/PM100.png";
import pm101 from "./assets/PM101.png";
import pm102 from "./assets/PM102.png";
import pm103 from "./assets/PM103.png";
import pm104 from "./assets/PM104.JPG";
import pm105 from "./assets/PM105.png";
import pm107 from "./assets/PM107.png";
import pm108 from "./assets/PM108.png";
import pm109 from "./assets/PM109.png";
import pm110 from "./assets/PM110.png";
import pm111 from "./assets/PM111.png";
import pm112 from "./assets/PM112.png";
import pm113 from "./assets/PM113.png";
import pm114 from "./assets/PM114.png";
import pm115 from "./assets/PM115.png";
import pm116 from "./assets/PM116.png";
import pm117 from "./assets/PM117.png";
import pm118 from "./assets/PM118.png";
import pm119 from "./assets/PM119.png";
import pm120 from "./assets/PM120.png";
import pm121 from "./assets/PM121.png";
import pm122 from "./assets/PM122.png";
import pm123 from "./assets/PM123.png";
import pm124 from "./assets/PM124.png";
import pm125 from "./assets/PM125.png";
import pm126 from "./assets/PM126.png";
import pm127 from "./assets/PM127.png";
import pm128 from "./assets/PM128.png";
import pm129 from "./assets/PM129.png";
import pm130 from "./assets/PM130.png";
import pm131 from "./assets/PM131.png";
import pm132 from "./assets/PM132.png";
import pm133 from "./assets/PM133.png";
import pm134 from "./assets/PM134.png";
import pm135 from "./assets/PM135.png";
import pm136 from "./assets/PM136.png";
import pm137 from "./assets/PM137.png";
import pm138 from "./assets/PM138.png";
import pm139 from "./assets/PM139.png";
import pm140 from "./assets/PM140.png";
import pm141 from "./assets/PM141.png";
import pm142 from "./assets/PM142.png";
import pm143 from "./assets/PM143.png";
import pm144 from "./assets/PM144.png";
import pm145 from "./assets/PM145.png";
import pm146 from "./assets/PM146.png";
import pm147 from "./assets/PM147.png";
import pm148 from "./assets/PM148.png";
import pm149 from "./assets/PM149.png";



export const PRODUCTS = {

    rangoli: [
    {
        id: 1,
        productName: 'Ganpati',
        price: 500,
        productImage: pm1,
    },
    {
        id: 2,
        productName: 'Lotus Diya',
        price: 200,
        productImage: pm2,
    },
    {
        id: 3,
        productName: 'Vasubaras',
        price: 400,
        productImage: pm3,
    },
    {
        id: 4,
        productName: 'Small hibiscus I (Pair)',
        price: 150,
        productImage: pm4,
    },
    {
        id: 5,
        productName: 'Small flower I (Pair)',
        price: 150,
        productImage: pm5,
    },
    {
        id: 6,
        productName: 'Rose',
        price: 150,
        productImage: pm6,
    },
    {
        id: 7,
        productName: 'Circle I',
        price: 100,
        productImage: pm7,
    },
    {
        id: 8,
        productName: 'Flower & Buds (Pair)',
        price: 200,
        productImage: pm8,
    },
    {
        id: 9,
        productName: 'Small flower II (Pair)',
        price: 150,
        productImage: pm9,
    },
    {
        id: 10,
        productName: 'Small flower III (Pair)',
        price: 150,
        productImage: pm10,
    },
    {
        id: 11,
        productName: 'Kalash & Shubhlabh',
        price: 400,
        productImage: pm11,
    },
    {
        id: 12,
        productName: 'Lakshmi paul',
        price: 100,
        productImage: pm12,
    },
    {
        id: 13,
        productName: 'Small flower IV (Pair)',
        price: 150,
        productImage: pm13,
    },
    {
        id: 14,
        productName: 'Nath',
        price: 200,
        productImage: pm14,
    },
    {
        id: 15,
        productName: 'Corner I (Pair)',
        price: 300,
        productImage: pm15,
    },
    {
        id: 16,
        productName: 'Small hibiscus II (Pair)',
        price: 150,
        productImage: pm16,
    },
    {
        id: 17,
        productName: 'Circle',
        price: 300,
        productImage: pm17,
    },
    {
        id: 18,
        productName: 'Peacock IV (Pair)',
        price: 400,
        productImage: pm18,
    },
    {
        id: 19,
        productName: 'Shree',
        price: 100,
        productImage: pm19,
    },
    {
        id: 20,
        productName: 'Shubh Labh',
        price: 200,
        productImage: pm20,
    },
    {
        id: 21,
        productName: 'Shubh Labh',
        price: 100,
        productImage: pm21,
    },
    {
        id: 22,
        productName: 'Kalash',
        price: 200,
        productImage: pm22,
    },
    {
        id: 23,
        productName: 'Om',
        price: 100,
        productImage: pm23,
    },
    {
        id: 24,
        productName: 'Ganpati & Peacock',
        price: 700,
        productImage: pm24,
    },
    {
        id: 25,
        productName: 'Peacock I',
        price: 400,
        productImage: pm25,
    },
    {
        id: 26,
        productName: 'Corner II',
        price: 150,
        productImage: pm26,
    },
    {
        id: 27,
        productName: 'Corner III (Pair)',
        price: 400,
        productImage: pm27,
    },
    {
        id: 28,
        productName: 'Small flower V (Pair)',
        price: 150,
        productImage: pm28,
    },
    {
        id: 29,
        productName: 'Border I (Pair)',
        price: 150,
        productImage: pm29,
    },
    {
        id: 30,
        productName: 'Small flower circle',
        price: 200,
        productImage: pm30,
    },
    {
        id: 31,
        productName: 'Peacock (Pair)',
        price: 400,
        productImage: pm31,
    },
    {
        id: 32,
        productName: 'Border II (Pair)',
        price: 150,
        productImage: pm32,
    },
    {
        id: 33,
        productName: 'Half Circle I (Pair)',
        price: 500,
        productImage: pm33,
    },
    {
        id: 34,
        productName: 'Circle',
        price: 300,
        productImage: pm34,
    },
    {
        id: 35,
        productName: 'Small Jasmine (8 Pieces)',
        price: 350,
        productImage: pm35,
    },
    {
        id: 36,
        productName: 'Border III (Pair)',
        price: 150,
        productImage: pm36,
    },
    {
        id: 37,
        productName: 'Circle',
        price: 100,
        productImage: pm37,
    },
    {
        id: 38,
        productName: 'Round Peacock (Pair)',
        price: 400,
        productImage: pm38,
    },
    {
        id: 39,
        productName: 'Small Flower VI (Pair)',
        price: 150,
        productImage: pm39,
    },
    {
        id: 40,
        productName: 'Small Flower VII (Pair)',
        price: 150,
        productImage: pm40,
    },
    {
        id: 41,
        productName: 'Name (Customizable)',
        price: 100,
        productImage: pm41,
    },
    {
        id: 42,
        productName: 'Diya',
        price: 150,
        productImage: pm42,
    },
    {
        id: 43,
        productName: 'Lotus (8 Pieces)',
        price: 350,
        productImage: pm43,
    },
    {
        id: 44,
        productName: 'Border IV (Pair)',
        price: 150,
        productImage: pm44,
    },
    {
        id: 45,
        productName: 'Elephant (Pair)',
        price: 500,
        productImage: pm45,
    },
    {
        id: 46,
        productName: 'Plate Design (Pair)',
        price: 300,
        productImage: pm46,
    },
    {
        id: 47,
        productName: 'Hand lotus & Lotus diya',
        price: 600,
        productImage: pm47,
    },
    {
        id: 48,
        productName: 'Circle',
        price: 100,
        productImage: pm48,
    },
    {
        id: 49,
        productName: 'Name (Customizable)',
        price: 100,
        productImage: pm49,
    },
    {
        id: 50,
        productName: 'Circle',
        price: 200,
        productImage: pm50,
    },
    {
        id: 51,
        productName: 'Jasmine (8 Pieces)',
        price: 350,
        productImage: pm51,
    },
    {
        id: 52,
        productName: 'Dashera',
        price: 300,
        productImage: pm52,
    },
    {
        id: 53,
        productName: 'Circle',
        price: 150,
        productImage: pm53,
    },
    {
        id: 54,
        productName: '8 pieces flower',
        price: 1000,
        productImage: pm54,
    },
    {
        id: 55,
        productName: 'Small Flower & Shubh Labh',
        price: 550,
        productImage: pm55,
    },
    {
        id: 56,
        productName: 'Welcome Lady',
        price: 300,
        productImage: pm56,
    },
    {
        id: 57,
        productName: 'Sitting Lady with Diya',
        price: 600,
        productImage: pm57,
    },
    {
        id: 58,
        productName: 'Half circle (Pair)',
        price: 400,
        productImage: pm58,
    },
    {
        id: 59,
        productName: 'Circle Zig Zag',
        price: 400,
        productImage: pm59,
    },
    {
        id: 60,
        productName: 'Standing Lady with Diya',
        price: 600,
        productImage: pm60,
    },
    {
        id: 61,
        productName: 'Samai (Pair)',
        price: 300,
        productImage: pm61,
    },
    {
        id: 62,
        productName: 'Gudi Padwa',
        price: 500,
        productImage: pm62,
    },
    {
        id: 63,
        productName: 'Laxmi Paul',
        price: 200,
        productImage: pm63,
    },
    {
        id: 64,
        productName: 'Paithani Saree',
        price: 600,
        productImage: pm64,
    },
    {
        id: 65,
        productName: 'Circle',
        price: 300,
        productImage: pm65,
    },
    {
        id: 66,
        productName: 'Kalash & Coin',
        price: 500,
        productImage: pm66,
    },
    {
        id: 67,
        productName: 'Ganesh ji',
        price: 300,
        productImage: pm67,
    },
    {
        id: 68,
        productName: 'Vitthal Rukmini',
        price: 1500,
        productImage: pm68,
    },
    {
        id: 69,
        productName: 'Balaji',
        price: 1500,
        productImage: pm69,
    },
    {
        id: 70,
        productName: 'Gauri (Pair)',
        price: 3000,
        productImage: pm70,
    },
    {
        id: 71,
        productName: 'Aptyache paan',
        price: 150,
        productImage: pm71,
    },
    {
        id: 72,
        productName: 'Krishna',
        price: 1000,
        productImage: pm72,
    },
    {
        id: 73,
        productName: 'Ram Sita',
        price: 1500,
        productImage: pm73,
    },
    {
        id: 74,
        productName: 'Pink flower',
        price: 150,
        productImage: pm74,
    },
    {
        id: 75,
        productName: 'Mahadev pind',
        price: 400,
        productImage: pm75,
    },
    {
        id: 76,
        productName: 'Hanuman',
        price: 1500,
        productImage: pm76,
    },
    {
        id: 77,
        productName: 'Radha Krishna',
        price: 1500,
        productImage: pm77,
    },
    {
        id: 78,
        productName: 'Mahadev & Trishul',
        price: 200,
        productImage: pm78,
    },
    {
        id: 79,
        productName: 'Zig Zag circle',
        price: 400,
        productImage: pm79,
    },
],

    matRangoli: [
    {
        id: 80,
        productName: 'Mat Rangoli 3x3 feet lotus peacock',
        price: 1200,
        productImage: pm80,
    },
    {
        id: 81,
        productName: 'Mat rangoli 3x3 feet',
        price: 1200,
        productImage: pm81,
    },
    {
        id: 82,
        productName: 'Mat rangoli 2x2 feet',
        price: 900,
        productImage: pm82,
    },
    {
        id: 83,
        productName: 'Mat rangoli 3x3 feet corner',
        price: 1200,
        productImage: pm83,
    },
    {
        id: 84,
        productName: 'Mat rangoli 2x2 feet (Pair)',
        price: 3000,
        productImage: pm84,
    },
    {
        id: 85,
        productName: 'Mat rangoli 3x3 feet',
        price: 1200,
        productImage: pm85,
    },
    {
        id: 86,
        productName: 'Laxmi Paul 1x1',
        price: 300,
        productImage: pm86,
    },
    {
        id: 87,
        productName: 'Half circle 3x3',
        price: 1200,
        productImage: pm87,
    },
    {
        id: 88,
        productName: 'Mat Rangoli 2x2 feet',
        price: 900,
        productImage: pm88,
    },
    {
        id: 89,
        productName: 'Swagatam Mat Rangoli',
        price: 1200,
        productImage: pm89,
    },
    {
        id: 90,
        productName: 'Mat Rangoli Flower',
        price: 200,
        productImage: pm90,
    },
    {
        id: 91,
        productName: 'Mat Rangoli 2x2 feet',
        price: 900,
        productImage: pm91,
    },
    {
        id: 92,
        productName: 'Mat Rangoli Laxmi Paul',
        price: 300,
        productImage: pm92,
    },
    {
        id: 93,
        productName: 'Mat Rangoli 3x3 feet',
        price: 1200,
        productImage: pm93,
    },
    {
        id: 94,
        productName: 'Mat Rangoli 2x2 feet',
        price: 900,
        productImage: pm94,
    },
    {
        id: 95,
        productName: 'Mat Rangoli Laxmi Paul',
        price: 300,
        productImage: pm95,
    },
    {
        id: 96,
        productName: 'Mat Rangoli peacock 3x3 feet',
        price: 1200,
        productImage: pm96,
    },
    {
        id: 97,
        productName: 'Mat Rangoli 2x2 feet',
        price: 900,
        productImage: pm97,
    },
    {
        id: 98,
        productName: 'Mat Rangoli 3x3 feet',
        price: 1200,
        productImage: pm98,
    },
    {
        id: 99,
        productName: 'Mat Rangoli 3x3 feet',
        price: 1200,
        productImage: pm99,
    },
    {
        id: 100,
        productName: 'Mat Rangoli Half Circle 2x2 feet',
        price: 800,
        productImage: pm100,
    },
    {
        id: 101,
        productName: 'Mat Rangoli Half Circle',
        price: 1000,
        productImage: pm101,
    },
    {
        id: 102,
        productName: 'Rose 1x1 feet',
        price: 150,
        productImage: pm102,
    },
    {
        id: 103,
        productName: 'Mat peacock feathers',
        price: 150,
        productImage: pm103,
    },
    {
        id: 104,
        productName: 'Mat Rangoli 2x2 feet',
        price: 900,
        productImage: pm104,
    },
    {
        id: 105,
        productName: 'Mat rangoli Lotus 1x1 feet',
        price: 150,
        productImage: pm105,
    }
],
    diwali: [
        {
            id: 107,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm107,
        },
        {
            id: 108,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm108,
        },
        {
            id: 109,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm109,
        },
        {
            id: 110,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm110,
        },
        {
            id: 111,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm111,
        },
        {
            id: 112,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm112,
        },
        {
            id: 113,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm113,
        },
        {
            id: 114,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm114,
        },
        {
            id: 115,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm115,
        },
        {
            id: 116,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm116,
        },
        {
            id: 117,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm117,
        },
        {
            id: 118,
            productName: 'Wax diya holder (Pair)',
            price: 185,
            productImage: pm118,
        },
        {
            id: 119,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm119,
        },
        {
            id: 120,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm120,
        },
        {
            id: 121,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm121,
        },
        {
            id: 122,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm122,
        },
        {
            id: 123,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm123,
        },
        {
            id: 124,
            productName: 'Wax diya holder (Pair)',
            price: 175,
            productImage: pm124,
        },
        {
            id: 125,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm125,
        },
        {
            id: 126,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm126,
        },
        {
            id: 127,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm127,
        },
        {
            id: 128,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm128,
        },
        {
            id: 129,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm129,
        },
        {
            id: 130,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm130,
        },
        {
            id: 131,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm131,
        },
        {
            id: 132,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm132,
        },
        {
            id: 133,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm133,
        },
        {
            id: 134,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm134,
        },
        {
            id: 135,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm135,
        },
        {
            id: 136,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm136,
        },
        {
            id: 137,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm137,
        },
        {
            id: 138,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm138,
        },
        {
            id: 139,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm139,
        },
        {
            id: 140,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm140,
        },
        {
            id: 141,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm141,
        },
        {
            id: 142,
            productName: 'Wax diya holder (Pair)',
            price: 165,
            productImage: pm142,
        },
        {
            id: 143,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm143,
        },
        {
            id: 144,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm144,
        },
        {
            id: 145,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm145,
        },
        {
            id: 146,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm146,
        },
        {
            id: 147,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm147,
        },
        {
            id: 148,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm148,
        },
        {
            id: 149,
            productName: 'Wax diya holder (Pair)',
            price: 350,
            productImage: pm149,
        }
    ]
}
   